import { render, staticRenderFns } from "./PaymentTestTableComponent.vue?vue&type=template&id=151b7ecc&scoped=true&"
import script from "./PaymentTestTableComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentTestTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTestTableComponent.vue?vue&type=style&index=0&id=151b7ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b7ecc",
  null
  
)

export default component.exports